export function FlipOut() {

    const $flipOut = document.querySelector('.flip-out'),
    $flipContainer = document.querySelector('.flip-out-wrapper'),
    $flipToogle = document.querySelectorAll('.flip-out-toggle');

    if ($flipOut) {
        console.log('FlipOut is ready');
        $flipToogle.forEach( element=> {
            element.addEventListener('click', (e) => {
                $flipOut.classList.toggle('open');
                $flipContainer.classList.toggle('is-open');
            });
        });
    }
}


